/* SALITRE — discount-popup.js: apertura única por sesión + alta newsletter por fetch */
(function () {
  'use strict';

  var SESSION_KEY = 'salitre:discountPopupShown';
  var popup = document.querySelector('[data-discount-popup]');
  if (!popup) return;

  var closeButtons = popup.querySelectorAll('[data-discount-popup-close]');
  var form = popup.querySelector('[data-discount-popup-form-wrap] form');
  var formWrap = popup.querySelector('[data-discount-popup-form-wrap]');
  var successPanel = popup.querySelector('[data-discount-popup-success]');
  var consentCheckbox = popup.querySelector('[data-discount-popup-consent]');
  var errorEl = popup.querySelector('.discount-popup__error');

  function openPopup() {
    popup.hidden = false;
    requestAnimationFrame(function () {
      popup.classList.add('is-open');
    });
  }

  function closePopup() {
    popup.classList.remove('is-open');
    setTimeout(function () {
      popup.hidden = true;
    }, 250);
  }

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hidden) closePopup();
  });

  if (!sessionStorage.getItem(SESSION_KEY)) {
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 4;
    setTimeout(function () {
      sessionStorage.setItem(SESSION_KEY, '1');
      openPopup();
    }, delay * 1000);
  }

  /* Alta newsletter vía fetch, sin recargar la página */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (consentCheckbox && !consentCheckbox.checked) {
        consentCheckbox.reportValidity && consentCheckbox.reportValidity();
        return;
      }
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (response) {
          if (response.ok) {
            formWrap.hidden = true;
            successPanel.hidden = false;
          } else if (errorEl) {
            errorEl.hidden = false;
          }
        })
        .catch(function () {
          if (errorEl) errorEl.hidden = false;
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }
})();
